import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a0b0d5be&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b0d5be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0b0d5be')) {
      api.createRecord('a0b0d5be', component.options)
    } else {
      api.reload('a0b0d5be', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a0b0d5be&scoped=true&", function () {
      api.rerender('a0b0d5be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22YY8Mvbxo6Sc/JS/comp/Accordion.vue"
export default component.exports